import './MessageBanner.css';

function MessageBanner({ message, type, url, onClose }) {
  if (!message && !url) return null;

  // Rich "website is live" card for successful creation
  if (type === 'success' && url) {
    return (
      <div className="live-banner" role="status">
        <div className="live-banner-icon" aria-hidden="true">
          <svg viewBox="0 0 24 24" width="26" height="26" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="20 6 9 17 4 12" />
          </svg>
        </div>

        <div className="live-banner-text">
          <div className="live-banner-title">Your website is now live!</div>
          <div className="live-banner-subtitle">
            Your new website has been successfully published and is ready for visitors.
          </div>
        </div>

        <div className="live-banner-divider" aria-hidden="true"></div>

        <a className="live-banner-url" href={url} target="_blank" rel="noopener noreferrer">
          <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" />
            <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" />
          </svg>
          <span className="live-banner-url-text">{url}</span>
          <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
            <polyline points="15 3 21 3 21 9" />
            <line x1="10" y1="14" x2="21" y2="3" />
          </svg>
        </a>

        <a className="live-banner-button" href={url} target="_blank" rel="noopener noreferrer">
          View Your Website
          <span aria-hidden="true">→</span>
        </a>

        <button className="live-banner-close" onClick={onClose} aria-label="Close message">
          ✕
        </button>
      </div>
    );
  }

  return (
    <div className={`message-banner ${type}`}>
      <div className="message-banner-content">
        <div className="message-banner-icon">
          {type === 'success' && '✅'}
          {type === 'error' && '❌'}
          {type === 'info' && 'ℹ️'}
          {type === 'warning' && '⚠️'}
        </div>
        <div className="message-banner-text">
          {message}
        </div>
        <button
          className="message-banner-close"
          onClick={onClose}
          aria-label="Close message"
        >
          ✕
        </button>
      </div>
    </div>
  );
}

export default MessageBanner;
